import { createFileRoute } from '@tanstack/react-router';
import { SetupReviewStep } from '@/pages/workspaces/transactional/message/setup/review-step/setup-review-step';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/review',
)({
  component: withRumPageRendered(SetupReviewStep),
});
